import { getNextOfKinForm } from '../../../selectors/personalAccident/nextOfKin';
import { getNextOfKinIsApiPending } from '../../../selectors/personalAccident/nextOfKin';
import { apiTransitionNextOfKinForm } from '../../../actions/personalAccident/nextOfKin';
import { getAccessToken } from '../../../selectors/personalAccident/payments';
import axios from 'axios';
import { getCustomerIdValue } from '../../../selectors/personalAccident/personalDetails';

export const nextOfKinSubmitService = (store, next, action) => {
    (async () => {
        if (!getNextOfKinIsApiPending(store.getState())) {
            store.dispatch(apiTransitionNextOfKinForm.pending());
            try {
                const resp = await makeSubmission(store.getState());

                if (resp.data) {
                    store.dispatch(apiTransitionNextOfKinForm.success());
                }
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionNextOfKinForm.failure());
            }
        }
    })();
    return next(action);
};

const payloadCollection = (state) => {
    const nextOfKin = getNextOfKinForm(state);
    const customerId = getCustomerIdValue(state);

    const payload = {
        id: customerId.value,
        fullName: `${nextOfKin?.firstName?.value || 'N/A'} ${nextOfKin?.lastName?.value || 'N/A'}`,
        relationship: nextOfKin.relationship.value || 'N/A',
        emailAddress: nextOfKin.email.value || 'N/A',
        gender: 'N/A',
        idNumber: nextOfKin.idNumber.value || 'N/A',
        phoneNumber: 'N/A',
        dateOfBirth: 'N/A',
        address: 'N/A',
    };

    return {
        ...payload,
    };
};

const makeSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/personal-accident/next-of-kin';
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
